(() => {
 function mount(root) {
  if (root.dataset.erMounted) return;
  root.dataset.erMounted = 'true';
  root.querySelectorAll('[data-er-enquiry]').forEach(link => {
   const filters = [...new URL(location.href).searchParams].filter(([key]) => ['filter.p.m.custom.gemstone_name','filter.p.m.custom.fine_jewellery_style','filter.p.m.custom.fine_jewellery_gemstone_shape'].includes(key)).map(([,value]) => value);
   const body = 'Hello Molten Store,\n\nI am looking for an engagement ring.' + (filters.length ? '\nMy selected filters: ' + filters.join(', ') : '') + '\n\nHere is what I have in mind:\n';
   link.href = root.dataset.enquiryEntryUrl + '&enquiry_message=' + encodeURIComponent(body);
  });
  const active = [...new URL(location.href).searchParams].filter(([key]) => key.startsWith('filter.'));
  if(active.length && !root.querySelector('.er-selected')) {
   const selected = document.createElement('div'); selected.className = 'er-selected';
   active.forEach(([key,value]) => {
    const link = document.createElement('a'); const url = new URL(location.href);
    url.searchParams.delete(key,value); url.searchParams.delete('page');
    link.href = url.href; link.textContent = value + ' ×'; link.setAttribute('aria-label','Remove ' + value); selected.append(link);
   });
   const clear = document.createElement('a'); const url = new URL(location.href);
   active.forEach(([key]) => url.searchParams.delete(key)); url.searchParams.delete('page');
   clear.href=url.href; clear.textContent='Clear all'; selected.append(clear); root.querySelector('.er-filters').append(selected);
  }
  const facets = [...root.querySelectorAll('.er-filters details')];
  facets.forEach(facet => facet.addEventListener('toggle', () => {
   if (facet.open) facets.forEach(other => { if(other !== facet) other.open = false; });
  }));
  root.addEventListener('keydown', event => {
   if(event.key === 'Escape') facets.filter(facet => facet.open).forEach(facet => { facet.open = false; facet.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => { if(!root.isConnected) return; if(!event.target.closest('.er-filters details')) facets.forEach(facet => { facet.open = false; }); });
  root.querySelectorAll('.er-filters a,.er-pagination a,[data-er-clear]').forEach(link => {
   const url = new URL(link.href);
   url.searchParams.set('view', root.dataset.erView);
   const preview = new URL(location.href).searchParams.get('preview_theme_id');
   if(preview) url.searchParams.set('preview_theme_id', preview);
   if(link.closest('.er-filters') || link.hasAttribute('data-er-clear')) url.searchParams.delete('page');
   link.href = url.href;
  });
 }
 document.querySelectorAll('[data-er-view]').forEach(mount);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-er-view]').forEach(mount));
})();
